/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
import { o_util } from "@gr-common/head/namespaces";
import { asExport } from "@gr-exports/head/core";
import { noop } from "@gr-common/head/function";
/**
 *
 */
export const event = asExport(o_util, "event", {});
/**
 *
 *
 *
 */
export const delegate = asExport(event, "delegate", noop);
/**
 *
 *
 *
 */
export const stop = asExport(event, "stop", noop);
/**
 *
 *
 *
 */
export const undelegate = asExport(event, "undelegate", noop);
/**
 *
 *
 *
 */
export const on = asExport(event, "on", noop);
/**
 *
 *
 *
 */
export const unsetAll = asExport(event, "unsetAll", noop);
/**
 *
 *
 *
 */
export const whichTransitionEndEvent = asExport(event, "whichTransitionEndEvent", noop);
